export default "__VITE_ASSET__CAVr6ho0__"